export enum VegaChartSignal {
  dataRecordHeight = 'dataRecordHeight',
  pageBoundaries = 'pageBoundaries',
}
